// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 883) return "module.component-v2-countdown.751f6eed83177d0501f8.min.js";
	if (chunkId === 7) return "module.component-v2-homepage-link.9bcaded11158a59c91b1.min.js";
	// return url for filenames based on template
	return undefined;
};